import _without from 'lodash/without';

import { LeaseStatus } from '@arrived/models';

export const leaseStatusFilterOptions = [
  {
    filter: null,
    label: { id: 'all', defaultMessage: 'All' },
  },
  {
    filter: LeaseStatus.OCCUPIED,
    label: { id: 'rented', defaultMessage: 'Rented' },
  },
  {
    filter: _without(Object.values(LeaseStatus), LeaseStatus.OCCUPIED),
    label: { id: 'seeking-tenant', defaultMessage: 'Seeking Tenant' },
  },
] as const;
